// extracted by mini-css-extract-plugin
module.exports = {"loader":"loadingStyles_loader__22Lcm","load8":"loadingStyles_load8__3dI67"};